import {sessionStore} from '../../../shared/SessionStore'
import {getEnv} from '../../../shared/env'
import {getPageName} from './helpers/getPageName'

type WithService = {service?: string}
type LogErrorInitSettings = Parameters<typeof Ya.Rum.initErrors>[0] & WithService
type LogErrorSettings = Parameters<typeof Ya.Rum.updateErrors>[0] & WithService

// нужно чтобы бустер ошибочно не конвертировал айдишники в числа
const prependId = (val?: string) => (val ? 'id:' + val : undefined)

if (!getEnv().LOGGER_DISABLE_RUM) {
  console.debug(`[rum] [${new Date().toISOString()}]:`, 'init_errors')

  const config: LogErrorInitSettings = {
    clck: 'https://yandex.ru/clck/click',
    reqid: sessionStore.data.requestId,
    project: 'eats-restapp',
    beacon: !!navigator.sendBeacon,
    env: sessionStore.data.env,
    version: sessionStore.data.version,
    page: getPageName(window.location.pathname),
    host: window.location.host,
    uncaughtException: true,
    unhandledRejection: true,
    traceUnhandledRejection: true,
    platform: sessionStore.data.platformType,
    pageMaxAge: 3 /*day*/ * 24 /*hours*/ * 60 /*minutes*/ * 60 /*seconds*/ * 1000 /*ms*/,
    service: sessionStore.data.service,
    additional: {
      parentRequestId: prependId(sessionStore.data.parentRequestId),
      platformVendor: sessionStore.data.platformVendor,
      sessionId: prependId(sessionStore.data.sessionId),
      partnerId: sessionStore.data.partnerId
    }
  }

  Ya.Rum.initErrors(config)
} else {
  console.debug(`[rum] [${new Date().toISOString()}]:`, 'init_errors_skip_by_env')
}

sessionStore.onDataChange(() => {
  const params: LogErrorSettings = {
    env: sessionStore.data.env,
    platform: sessionStore.data.platformType,
    version: sessionStore.data.version,
    service: sessionStore.data.service,
    additional: {
      parentRequestId: prependId(sessionStore.data.parentRequestId),
      platformVendor: sessionStore.data.platformVendor,
      sessionId: prependId(sessionStore.data.sessionId),
      partnerId: sessionStore.data.partnerId
    }
  }

  Ya.Rum.updateErrors(params)
})
